import { WidgetEvents } from "../widgets";

export type CedeEvents =
  | "connect"
  | "disconnect"
  | "accountsChanged"
  | "newAccountStatus"
  | "lock"
  | "unlock"
  | "exchangesStatusesUpdate"
  | "trackLogin"
  | WidgetEvents;

export enum CedeSDKEvents {
  CACHE_UPDATE = "cache-update",
  CACHE_DELETE = "cache-delete",
  OAUTH_REVOKED = "oauth-revoked",
  OAUTH_REFRESHED = "oauth-refreshed",
  ERROR = "error",
}

export enum HydrationItem {
  BALANCES = "balances",
}

export * from "./widget";
